"use client";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalOverlay.module.scss";

const ModalOverlay = () => {
  const { absolutePosition, state, animation, contentReady, onExitComplete } =
    useModal();
  return (
    <div
      className={styles["modal-overlay"]}
      data-absolute-position={absolutePosition}
      data-state={state}
      data-animation={animation}
      data-content-ready={contentReady}
      // The overlay finishes last in both presets, including the staggered delay.
      onAnimationEnd={(event) => {
        if (
          event.target === event.currentTarget &&
          event.animationName === styles["modal-overlay-fade-out"]
        ) {
          onExitComplete();
        }
      }}
    ></div>
  );
};

export default ModalOverlay;
